import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Cloud_Security from "../Assets/Articles/Cloud Security.jpg"
import Ethical_hacking from "../Assets/Articles/Ethical Hacking.jpg"
import PowerNet from "../Assets/Articles/The power of network segmentation.jpg"
import Portfolio from "../Assets/ARTS/NATURE.jpg"
import { GrProjects, GrScorecard } from "react-icons/gr";
import Care_Connect from "../Assets/ARTS/0.jpg"
import W2edax from "../Assets/ARTS/w2edax.jpg"
import Pomo from "../Assets/ARTS/pomo.png"
import Kingdom_tower from "../Assets/kingdom-tower.svg"



// import images for projects
// add badges within experience section
// make it responsive


import {
  SiDotnet,
  SiAndroid,
  SiAndroidstudio,
  SiFirebase,
  SiGooglemaps,
  SiMicrosoftazure,
  SiReact,
  SiTailwindcss,
  SiElectron,
} from "react-icons/si";
import { FaAngular } from "react-icons/fa";

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, when: "beforeChildren", staggerChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
};

const Projects = () => {
  const [ref, inView] = useInView({ triggerOnce: false });

  const projects = [
    {
      title: "Care Connect",
      description: "Blood donation social platform",
      techStack: [<SiAndroidstudio />, <SiFirebase />, <SiAndroid />, <SiGooglemaps />],
      link: "https://github.com/TUNKSTUN/BloodBank-master",
      image: Care_Connect, // Directly pass the image path
    },
    {
      title: "W²EDAX",
      description: "Cybersecurity blog platform",
      techStack: [<FaAngular />, <SiDotnet />, <SiMicrosoftazure />],
      link: "https://w2edax.web.app",
      image: W2edax, // Directly pass the image path
    },
    {
      title: "tunkstun.web.app",
      description: "Personal portfolio",
      techStack: [<SiReact />, <SiFirebase />, <SiTailwindcss />],
      link: "https://github.com/tunkstun/tunkstun1",
      image: Portfolio, // Directly pass the image path
    },
    {
      title: "POMODORO",
      description: "Productivity desktop app",
      techStack: [<SiElectron />, <SiTailwindcss />],
      link: "https://github.com/tunkstun/pomodoro",
      image: Pomo, // Directly pass the image path
    },
  ];  

  const experience = [
    {
      title: "Network Infrastructure Engineer",
      company: "IKNASOFT",
      period: "2022 - Present",
      description:
        "Lead network infrastructure projects and implementing cloud solutions in KSA",
      skills: ["Network Design", "Cloud Architecture", "Security"],
    },
    {
      title: "IT Engineer",
      company: "ATMECS Tech",
      period: "2021 - 2022",
      description: "Managed IT infrastructure and provided support",
      skills: ["Systems Administration", "Automation", "DevOps"],
    },
  ];

  return (
    <div id="experience"  className="min-h-screen bg-black text-white py-16">
      
      
      <motion.div
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        className="max-w-7xl mx-auto px-4"
      >
        {/* Experience Section */}
        <motion.section variants={itemVariants} className="mb-24 " >
          <h2 className="sm:text-3xl md:text-4xl text-5xl font-[rekind] mb-2 items-center gap-8 flex text-cyan-400"><GrScorecard/> Experience</h2>
          <div className="h-1 w-40 bg-cyan-400 rounded-full mb-12" />
          <p className="text-zinc-400 mb-6 sm:text-[16px] md:text-lg text-xl">
            Professional experience across roles in IT engineering and network infrastructure, with a focus on cloud solutions, automation, and system administration.
          </p>
          <div className="grid grid-cols-1 gap-8">
            {experience.map((exp, index) => (
              <motion.div
              key={index}
              variants={itemVariants}
              className="bg-zinc-900 text-cyan-400 p-6 rounded-lg border overflow-hidden backdrop-blur-md border-cyan-100/10 hover:border-cyan-400/40 transition-all"
              >
                <h3 className="text-2xl sm:text-xl md:text-xl font-[rekind]">{exp.title}</h3>
                <p className="text-zinc-300 text-xl sm:text-sm font-semibold mb-2">{exp.company}</p>
                <p className="text-zinc-400 sm:text-sm text-lg mb-4">{exp.period}</p>
                <p className="text-zinc-300 sm:text-sm text-lg mb-4">{exp.description}</p>
                <div className="flex flex-wrap gap-2">
                  <img src={Kingdom_tower} alt="kingdowm" className=" w-96 h-64 sm:w-full md:w-full sm:h-full md:h-full sm:inset-0 md:inset-0 sm:object-cover md:object-cover -right-10 top-10 opacity-15 mix-blend-color-dodge items-center justify-center flex absolute "/>
                  {exp.skills.map((skill, i) => (
                    <span key={i} className="px-3 py-1 bg-cyan-500 border-cyan-200 text-sm rounded-full text-zinc-900 font-bold">
                      {skill}
                    </span>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.section>
        {/* Projects Section */}
        <motion.section variants={itemVariants} className="mb-24" >
          <h1 id="projects" className="sm:text-3xl md:text-4xl text-5xl flex gap-8 items-center font-[rekind] mb-2 text-cyan-400"><GrProjects/>Projects</h1>
          <div className="h-1 w-40 bg-cyan-400 rounded-full mb-12" />
          <p className="text-zinc-400 mb-6 sm:text-[16px] text-xl">
            A collection of diverse projects showcasing skills in mobile app development, web platforms, and productivity tools, utilizing modern technologies such as React, Angular, .NET, Firebase, and Electron.
          </p>
          <div className="grid sm:grid-cols-1 grid-cols-2 gap-6">
  {projects.map((project) => (
    <motion.div
      key={project.title}
      variants={itemVariants}
      className="relative bg-zinc-900 text-cyan-400 p-6 rounded-lg border border-white/10 hover:border-white/20 object-contain transition-all h-full flex flex-col overflow-hidden"
    >
      {/* Large Circle Background */}
      <div
    className="absolute -top-40 -right-40 w-96 h-96 rounded-full opacity-80 border-cyan-400 border bg-white transition-all duration-300 backdrop-blur-lg"
    style={{ backgroundImage: `url(${project.image})` }}
  ></div>

  <h2 className="text-2xl sm:text-lg md:text-lg font-[rekind] mb-3 relative z-10">{project.title}</h2>
  <p className="text-zinc-400 mb-4 text-xl sm:text-sm md:text-lg text-wrap flex-grow relative z-10">{project.description}</p>
  <div className="flex gap-3 mb-4 relative z-10">
    {project.techStack.map((tech, i) => (
      <span key={i} className="text-white/70 text-2xl">
        {tech}
      </span>
    ))}
  </div>
  <a
    href={project.link}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-block px-4 py-2 w-auto border z-20 bg-zinc-900 border-white/20 rounded hover:bg-cyan-200 hover:text-black transition-all relative"
  >
    View Project
  </a>
    </motion.div>
  ))}
</div>

        </motion.section>

        
      </motion.div>
    </div>
  );
};

export default Projects;
